import { render, staticRenderFns } from "./TutorialsView.vue?vue&type=template&id=013b0a90&scoped=true&"
import script from "./TutorialsView.vue?vue&type=script&lang=js&"
export * from "./TutorialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b0a90",
  null
  
)

export default component.exports